import UserAdmin from "../components/admin/user/user";

const Admin = () => {
  return (
    <div className="flex flex-col w-full gap-8 sm:flex-row">
      <UserAdmin />
    </div>
  );
};

export default Admin;
